// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wZsNS","title":"Header_title__I64pQ","search":"Header_search__+NiGY","main-image":"Header_main-image__Zbn67"};